import React, { useState } from "react";
import "./contact.css";

const MAP_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14443.086880955569!2d55.32748190139345!3d25.177184793578103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f67b60a815999%3A0xa5fa31866258329a!2sRas%20Al%20Khor%20Industrial%20Area%20-%20Ras%20Al%20Khor%20Industrial%20Area%201%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2s!4v1774943980268!5m2!1sen!2s";

const ContactInfo = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    service: "",
    area: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const text = [
      `Hi, I want to book a refrigerated transport service.`,
      `Name: ${form.name}`,
      `Phone: ${form.phone}`,
      form.service ? `Service: ${form.service}` : "",
      form.area ? `Route / Area: ${form.area}` : "",
      form.message ? `Message: ${form.message}` : "",
    ]
      .filter(Boolean)
      .join("\n");

    window.open(
      `https://wa.me/971544792905?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  return (
    <section className="contact-form-section">
      <div className="container">
        <div className="row align-items-stretch gy-5">

          {/* Left — Form */}
          <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-duration="1400"
            data-aos-easing="ease-out-cubic"
            data-aos-once="true"
          >
            <div className="contact-form-wrapper">
              <h2>Send Us a Message</h2>
              <p>Fill in your details and we'll get back to you via WhatsApp shortly.</p>

              <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label" htmlFor="name">Full Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="Your name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label" htmlFor="phone">Phone / WhatsApp Number</label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    className="form-control"
                    placeholder="+971 XX XXX XXXX"
                    value={form.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label" htmlFor="service">Service Required</label>
                  <select
                    id="service"
                    name="service"
                    className="form-select"
                    value={form.service}
                    onChange={handleChange}
                  >
                    <option value="">Select a service</option>
                    <option>Chiller Van Rental</option>
                    <option>Freezer Van Rental</option>
                    <option>Chiller Truck Rental</option>
                    <option>Freezer Truck Rental</option>
                    <option>Refrigerated Truck Rental</option>
                    <option>High Roof Van Rental</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label" htmlFor="area">Route / Delivery Area</label>
                  <input
                    id="area"
                    name="area"
                    type="text"
                    className="form-control"
                    placeholder="e.g. Dubai to Sharjah"
                    value={form.area}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label" htmlFor="message">Additional Requirements</label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-control"
                    rows={4}
                    placeholder="Temperature range, cargo type, schedule..."
                    value={form.message}
                    onChange={handleChange}
                  />
                </div>

                <button type="submit" className="contact-form-submit">
                  <i className="bi bi-whatsapp me-2"></i>
                  Send via WhatsApp
                </button>
              </form>
            </div>
          </div>

          {/* Right — Map */}
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1400"
            data-aos-easing="ease-out-cubic"
            data-aos-once="true"
          >
            <div className="contact-map-wrapper">
              <iframe
                title="Chiller Fleet Transport — Ras Al Khor Location"
                src={MAP_EMBED}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
